import { render, staticRenderFns } from "./H5Component.vue?vue&type=template&id=55c7f3ed&scoped=true"
import script from "./H5Component.vue?vue&type=script&lang=js"
export * from "./H5Component.vue?vue&type=script&lang=js"
import style0 from "./H5Component.vue?vue&type=style&index=0&id=55c7f3ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c7f3ed",
  null
  
)

export default component.exports